import { render, staticRenderFns } from "./listarpagamentoemolumento.vue?vue&type=template&id=24639f5c&"
import script from "./listarpagamentoemolumento.vue?vue&type=script&lang=js&"
export * from "./listarpagamentoemolumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports